import { useState } from "react";
import { useTranslation } from "react-i18next";
import AutoFormDialog from "../dialogTypes/AutoFormDialog";
import CreateRecordButtonLayout from "../layout/CreateRecordButtonLayout";

function CreateStockTakingButton(props) {

  const { t } = useTranslation();

  const { id, schema, refresh, onSuccess, stockTakingType, ...others } = props;
  
  const [open, setOpen] = useState(false);

  const onOpen = () => {

    setOpen(true);

  };

  const onClose = () => {

    setOpen(false);

  };

  const onCreateSuccess = (msg) => {

    if (onSuccess) {

      onSuccess(msg);

    }

    refresh.refresh();

  };


  const setInitialDataCallback = ( formData ) => {

    if ( !formData ) {

        formData = {};
        
    }
  
    formData.stockTakingType = stockTakingType;
  }


  return (
    <>
      <CreateRecordButtonLayout id={id + "create-button"}onClick={onOpen}{...others} createButtonName = {"newStockTaking"}/>
      <AutoFormDialog
        id={id + "create-dialog"}
        mode="create"
        formId={id + "create-form"}
        title={schema ? t(`dialog.title.${schema.name}.${'create'}`) : ""}
        schema={schema}
        initialData={undefined}
        open={open}
        onClose={onClose}
        onSuccess={onCreateSuccess}
        setInitialDataCallback= {setInitialDataCallback}
      />
    </> 
  );
}

export default CreateStockTakingButton;
